import request from '@/utilsCloud/request'
import port from './port'


// 获取专业课程课程包列表
export function exerciseRecordResult(query) {
  return request({
    url: port.exam + '/exercise/exerciseRecordResult',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/testResult.js